import {
  AGENT_BUILDER_ROUTE,
  CHAT_SESSION_PARAM,
  CHAT_SESSION_ROUTE,
  INVESTIGATION_CHAT_PARAM,
  INVESTIGATION_ROUTE,
} from '@/config/constants';

type QueryValue = string | string[] | undefined;

type ResolveNavigationChatSessionIdArgs = {
  sessionId?: string;
  fallbackChatSessionId?: string;
  pathname: string;
  query: Record<string, QueryValue>;
};

const firstQueryValue = (value: QueryValue) => (Array.isArray(value) ? value[0] : value);

export const resolveNavigationChatSessionId = ({
  sessionId,
  fallbackChatSessionId,
  pathname,
  query,
}: ResolveNavigationChatSessionIdArgs) => {
  if (sessionId) return sessionId;
  if (pathname === CHAT_SESSION_ROUTE) return firstQueryValue(query[CHAT_SESSION_PARAM]) ?? fallbackChatSessionId;
  if (pathname === INVESTIGATION_ROUTE || pathname === AGENT_BUILDER_ROUTE) {
    return firstQueryValue(query[INVESTIGATION_CHAT_PARAM]) ?? fallbackChatSessionId;
  }
  return fallbackChatSessionId;
};
